/* TheYayaCafe — product personaliser (PDP). Dependency-free.

   Live preview happens ON the main product gallery image (not a separate box):
   we composite the mockup + typed name + uploaded photo onto an off-screen
   canvas and feed the result back into the featured gallery <img> via a data
   URL. Clearing everything restores the original image. This reuses Dawn's own
   responsive gallery sizing, and the preview is as large as the product photo.

   File uploads & the cart:
   Shopify's AJAX cart (/cart/add.js, what Dawn's product-form.js uses) silently
   drops file inputs, so a photo can only persist via a NATIVE multipart POST to
   /cart/add. We intercept the product form's submit in the CAPTURE phase (before
   Dawn's listener on the <form>): no photo -> let Dawn's AJAX run (cart drawer);
   a photo IS chosen -> set enctype=multipart/form-data, stop the event reaching
   Dawn's handler, and let the browser do the native POST (lands on /cart). Empty
   optional fields are disabled so they aren't submitted.

   Markup contract (snippets/tyyc-personaliser.liquid):
     [data-personaliser]   root, carries data-config / data-mockup
                           / data-has-name / data-has-photo
       [data-pers-text="Name"]   text input (name="properties[Name]")
       [data-pers-count="Name"]  optional "n/max" counter
       [data-pers-file]          file input (name="properties[Photo]")
       [data-pers-error]         inline error/status node                        */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-personaliser]');
  if (!roots.length) return;

  function safeParse(s) {
    if (!s) return {};
    try { var v = JSON.parse(s); return v && typeof v === 'object' ? v : {}; }
    catch (e) { return {}; }
  }
  function applyTransform(str, t) {
    if (!str) return str;
    if (t === 'uppercase') return str.toUpperCase();
    if (t === 'lowercase') return str.toLowerCase();
    return str;
  }
  function drawCover(ctx, img, x, y, w, h) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    if (!iw || !ih) return;
    var s = Math.max(w / iw, h / ih), dw = iw * s, dh = ih * s;
    ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
  }
  function drawContain(ctx, img, x, y, w, h) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    if (!iw || !ih) return;
    var s = Math.min(w / iw, h / ih), dw = iw * s, dh = ih * s;
    ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
  }
  function roundRect(ctx, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }
  function clipZone(ctx, z) {
    ctx.beginPath();
    if (z.shape === 'circle') ctx.arc(z.x + z.w / 2, z.y + z.h / 2, Math.min(z.w, z.h) / 2, 0, Math.PI * 2);
    else if (z.radius > 0) roundRect(ctx, z.x, z.y, z.w, z.h, z.radius);
    else ctx.rect(z.x, z.y, z.w, z.h);
    ctx.clip();
  }

  roots.forEach(init);

  function init(root) {
    var cfg = safeParse(root.getAttribute('data-config'));
    var hasName = root.getAttribute('data-has-name') === '1';
    var hasPhoto = root.getAttribute('data-has-photo') === '1';

    var preview = cfg.preview && cfg.preview.w && cfg.preview.h ? cfg.preview : { w: 1000, h: 1000 };
    var W = preview.w, H = preview.h;
    var textZones = hasName ? (Array.isArray(cfg.text) ? cfg.text : [defaultTextZone(W, H)]) : [];
    var imageZones = hasPhoto ? (Array.isArray(cfg.image) ? cfg.image : [defaultImageZone(W, H)]) : [];

    // The featured product image we composite onto, scoped to this product section.
    var container = root.closest('[id^="MainProduct-"]') || document;
    var targetImg = container.querySelector('.product__media-list .product__media-item img')
      || container.querySelector('.product__media-item img')
      || container.querySelector('.product__media img');
    var orig = targetImg
      ? { src: targetImg.getAttribute('src'), srcset: targetImg.getAttribute('srcset'), sizes: targetImg.getAttribute('sizes') }
      : null;

    // Off-screen working canvas, rendered crisp (~1445px wide to match Dawn's src).
    var renderScale = 1445 / W;
    var canvas = document.createElement('canvas');
    canvas.width = Math.round(W * renderScale);
    canvas.height = Math.round(H * renderScale);
    var ctx = canvas.getContext('2d');

    // Mockup base. Use a width that differs from the gallery's src so the
    // crossOrigin fetch isn't served from a non-CORS cache entry (avoids taint).
    var mockupSrc = root.getAttribute('data-mockup') || (orig && orig.src) || '';
    var mockupImg = null, userImg = null, values = {};
    if (mockupSrc) {
      mockupImg = new Image();
      mockupImg.crossOrigin = 'anonymous';
      mockupImg.onload = scheduleDraw;
      mockupImg.onerror = function () { mockupImg = null; };
      mockupImg.src = mockupSrc;
    }

    root.querySelectorAll('[data-pers-text]').forEach(function (inp) {
      var prop = inp.getAttribute('data-pers-text');
      values[prop] = inp.value || '';
      var counter = root.querySelector('[data-pers-count="' + prop + '"]');
      var max = inp.maxLength > 0 ? inp.maxLength : null;
      var syncCount = function () { if (counter && max != null) counter.textContent = inp.value.length + '/' + max; };
      syncCount();
      inp.addEventListener('input', function () { values[prop] = inp.value || ''; syncCount(); scheduleDraw(); });
    });

    var fileInp = root.querySelector('[data-pers-file]');
    var errEl = root.querySelector('[data-pers-error]');
    if (fileInp) {
      var zone = imageZones[0] || {};
      var maxMB = zone.maxMB || 10;
      fileInp.addEventListener('change', function () {
        setError('');
        var f = fileInp.files && fileInp.files[0];
        if (!f) { releaseUserImg(); scheduleDraw(); return; }
        if (!/^image\//.test(f.type)) { setError('Please choose an image file (JPG, PNG or WebP).'); fileInp.value = ''; releaseUserImg(); scheduleDraw(); return; }
        if (f.size > maxMB * 1024 * 1024) { setError('That photo is too large (max ' + maxMB + ' MB). Please pick a smaller one.'); fileInp.value = ''; releaseUserImg(); scheduleDraw(); return; }
        var url = URL.createObjectURL(f);
        var im = new Image();
        im.onload = function () { releaseUserImg(); userImg = im; userImg._url = url; scheduleDraw(); };
        im.onerror = function () { URL.revokeObjectURL(url); setError('Sorry, that image could not be read. Try another photo.'); releaseUserImg(); scheduleDraw(); };
        im.src = url;
      });
    }
    function releaseUserImg() { if (userImg && userImg._url) { try { URL.revokeObjectURL(userImg._url); } catch (e) {} } userImg = null; }
    function setError(msg) { if (errEl) errEl.textContent = msg; }

    function hasContent() {
      if (userImg) return true;
      for (var k in values) { if (values[k] && values[k].trim()) return true; }
      return false;
    }

    var raf = 0;
    function scheduleDraw() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; draw(); }); }

    // Composite the current state onto the working canvas. Returns false (no draw)
    // when nothing is personalised yet.
    function renderComposite() {
      if (!hasContent()) return false;
      ctx.setTransform(renderScale, 0, 0, renderScale, 0, 0); // author in preview units
      ctx.clearRect(0, 0, W, H);
      if (mockupImg) drawCover(ctx, mockupImg, 0, 0, W, H);
      else { ctx.fillStyle = cfg.bg || '#f1ece4'; ctx.fillRect(0, 0, W, H); }

      if (userImg) {
        imageZones.forEach(function (z) {
          ctx.save();
          clipZone(ctx, z);
          if ((z.fit || 'cover') === 'contain') drawContain(ctx, userImg, z.x, z.y, z.w, z.h);
          else drawCover(ctx, userImg, z.x, z.y, z.w, z.h);
          ctx.restore();
        });
      }

      textZones.forEach(function (z) {
        var raw = (values[z.property] || '').trim();
        if (!raw) return;
        var shown = applyTransform(raw, z.transform);
        ctx.save();
        ctx.textAlign = z.align || 'center';
        ctx.textBaseline = 'middle';
        var px = fitFontPx(ctx, shown, z);
        ctx.font = (z.weight || 700) + ' ' + px + 'px ' + (z.font || 'sans-serif');
        if (z.strokePx) { ctx.lineWidth = z.strokePx; ctx.strokeStyle = z.stroke || 'rgba(0,0,0,.35)'; ctx.lineJoin = 'round'; ctx.strokeText(shown, z.x, z.y); }
        ctx.fillStyle = z.color || '#2a2a2a';
        ctx.fillText(shown, z.x, z.y);
        ctx.restore();
      });
      return true;
    }

    function draw() {
      if (!targetImg) return;
      if (!renderComposite()) { restore(); return; } // nothing personalised yet → original image
      var url;
      try { url = canvas.toDataURL('image/jpeg', 0.92); }
      catch (e) { return; }                          // tainted canvas (CORS) → leave gallery as-is
      targetImg.setAttribute('src', url);
      targetImg.removeAttribute('srcset');           // else the browser keeps using srcset, ignoring src
      targetImg.removeAttribute('sizes');
      scrollHintOnce();
    }

    // Snapshot the composite as a data URL for attaching to the order. null when
    // there's nothing personalised or the canvas can't be exported (CORS).
    root.__persSnapshot = function () {
      if (!renderComposite()) return null;
      try { return canvas.toDataURL('image/jpeg', 0.9); } catch (e) { return null; }
    };

    function restore() {
      if (!targetImg || !orig) return;
      if (orig.src != null) targetImg.setAttribute('src', orig.src); else targetImg.removeAttribute('src');
      if (orig.srcset != null) targetImg.setAttribute('srcset', orig.srcset); else targetImg.removeAttribute('srcset');
      if (orig.sizes != null) targetImg.setAttribute('sizes', orig.sizes); else targetImg.removeAttribute('sizes');
    }

    var hinted = false;
    function scrollHintOnce() {
      if (hinted) return; hinted = true;
      // On first change, nudge the featured image into view if it's off-screen.
      var r = targetImg.getBoundingClientRect();
      if (r.bottom < 0 || r.top > (window.innerHeight || 0)) targetImg.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function fitFontPx(ctx, text, z) {
      var px = z.fontPx || 80;
      if (!z.maxWidth) return px;
      var floor = z.minFontPx || 18;
      while (px > floor) {
        ctx.font = (z.weight || 700) + ' ' + px + 'px ' + (z.font || 'sans-serif');
        if (ctx.measureText(text).width <= z.maxWidth) break;
        px -= 2;
      }
      return px;
    }

    ensureFonts(textZones, scheduleDraw);            // redraw once webfonts are ready
  }

  function defaultTextZone(W, H) {
    return {
      property: 'Name', transform: 'uppercase',
      font: "'Fredoka','Poppins',sans-serif", weight: 700,
      fontPx: Math.round(H * 0.1), minFontPx: 20,
      color: '#ffffff', stroke: 'rgba(0,0,0,.35)', strokePx: Math.round(H * 0.008),
      align: 'center', x: W / 2, y: Math.round(H * 0.84), maxWidth: Math.round(W * 0.84)
    };
  }
  function defaultImageZone(W, H) {
    var s = Math.round(Math.min(W, H) * 0.5);
    return { property: 'Photo', shape: 'rect', fit: 'cover', radius: Math.round(s * 0.04), x: Math.round((W - s) / 2), y: Math.round(H * 0.16), w: s, h: s, maxMB: 10 };
  }

  function ensureFonts(zones, cb) {
    if (!document.fonts || !document.fonts.load) return;
    var loads = zones.map(function (z) {
      try { return document.fonts.load((z.weight || 700) + ' ' + (z.fontPx || 80) + 'px ' + (z.font || 'sans-serif')); }
      catch (e) { return Promise.resolve(); }
    });
    Promise.all(loads).then(cb, cb);
  }

  /* ---- cart submit interception (capture phase, before Dawn) ------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var root = findRootForForm(form.id);
    if (!root) return;

    var missing = firstMissingRequired(root);
    if (missing) {
      e.preventDefault(); e.stopImmediatePropagation();
      var err = root.querySelector('[data-pers-error]'); if (err) err.textContent = missing;
      var fo = root.querySelector('[data-pers-text],[data-pers-file]'); if (fo) fo.focus();
      return;
    }

    var disabled = [];
    root.querySelectorAll('[data-pers-text]').forEach(function (inp) {
      if (!inp.value.trim() && !inp.disabled) { inp.disabled = true; disabled.push(inp); }
    });
    if (disabled.length) setTimeout(function () { disabled.forEach(function (i) { i.disabled = false; }); }, 0);

    // Attach the rendered composite as properties[_Preview] so the order shows
    // exactly what the customer designed (alongside their original photo + text).
    var snap = typeof root.__persSnapshot === 'function' ? root.__persSnapshot() : null;
    var prev = root.querySelector('[data-pers-preview]');
    var attachedPreview = false;
    if (prev) {
      prev.disabled = true;                          // default: don't submit an empty preview
      if (snap) {
        try {
          var f = new File([dataURLToBlob(snap)], 'preview.jpg', { type: 'image/jpeg' });
          var dt = new DataTransfer(); dt.items.add(f);
          prev.files = dt.files;
          prev.disabled = false;
          attachedPreview = true;
        } catch (err) { prev.disabled = true; }       // File/DataTransfer unsupported → skip preview
      }
    }

    var fileInp = root.querySelector('[data-pers-file]');
    var hasFile = fileInp && fileInp.files && fileInp.files.length > 0;
    if (hasFile || attachedPreview) {
      // Files only persist via a native multipart POST — Dawn's AJAX cart drops them.
      form.setAttribute('enctype', 'multipart/form-data');
      e.stopImmediatePropagation();                  // skip Dawn's AJAX handler; browser does native POST
    }
  }, true);

  function dataURLToBlob(d) {
    var parts = d.split(','), mime = (parts[0].match(/:(.*?);/) || [])[1] || 'image/jpeg';
    var bstr = atob(parts[1]), n = bstr.length, u8 = new Uint8Array(n);
    while (n--) u8[n] = bstr.charCodeAt(n);
    return new Blob([u8], { type: mime });
  }

  function findRootForForm(formId) {
    var all = document.querySelectorAll('[data-personaliser]');
    for (var i = 0; i < all.length; i++) {
      var ctrl = all[i].querySelector('[data-pers-text],[data-pers-file]');
      if (ctrl && ctrl.getAttribute('form') === formId) return all[i];
    }
    return null;
  }
  function firstMissingRequired(root) {
    var msg = null;
    root.querySelectorAll('[data-pers-text][data-pers-required="1"]').forEach(function (inp) {
      if (!msg && !inp.value.trim()) msg = 'Please add the ' + (inp.getAttribute('data-pers-label') || 'text') + ' before adding to cart.';
    });
    var f = root.querySelector('[data-pers-file][data-pers-required="1"]');
    if (!msg && f && !(f.files && f.files.length)) msg = 'Please upload a photo before adding to cart.';
    return msg;
  }
})();
